(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiseaseDialogController', DiseaseDialogController);

    DiseaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Disease', 'DiseaseType'];

    function DiseaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Disease, DiseaseType) {
        var vm = this;
        vm.disease = entity;
        vm.diseasetypes = DiseaseType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:diseaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.disease.id !== null) {
                Disease.update(vm.disease, onSaveSuccess, onSaveError);
            } else {
                Disease.save(vm.disease, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
